import { useState, useEffect } from 'react'

const DURATION = 15 * 60 // 15 minutes in seconds
const KEY = 'ceroatrasos_timer_end'

export function useCountdown() {
  const [remaining, setRemaining] = useState<number | null>(null)
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    let endTimeStr = localStorage.getItem(KEY)
    let endTime: number

    if (!endTimeStr) {
      endTime = Date.now() + DURATION * 1000
      localStorage.setItem(KEY, endTime.toString())
    } else {
      endTime = parseInt(endTimeStr, 10)
    }

    const update = () => {
      const now = Date.now()
      const rem = Math.max(0, Math.floor((endTime - now) / 1000))

      setRemaining(rem)

      if (rem <= 0) {
        setIsExpired(true)
      }
    }

    update()
    const interval = setInterval(update, 1000)

    return () => clearInterval(interval)
  }, [])

  const formatTime = (seconds: number | null) => {
    if (seconds === null) return '15:00'
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
  }

  return {
    formattedTime: formatTime(remaining),
    isExpired,
  }
}
